export const awsConfig = {
  name: "aws",
  displayName: "AWS",
  description:
    "AWS Identity and Access Management security monitoring and analysis",
  icon: "/inte/AWS.png",
  category: "Cloud Infrastructure",

  onboarding: {
    enabled: true,
    route: "/manage-scans",
    buttonText: "New Scan",
  },

  // API Endpoints (kept for compatibility; not used in mock mode)
  endpoints: {
    list: {
      url: "api/iam-scans",
      method: "GET",
    },
    details: "api/iam-scans/{id}",
    findings: {
      url: "api/iam-scans/{id}/findings",
      method: "GET",
      useFilters: true,
    },
    schedules: {
      list: "api/iam-scan-schedules",
      create: "api/iam-scan-schedules",
      get: "api/iam-scan-schedules/{id}",
      update: "api/iam-scan-schedules/{id}",
      delete: "api/iam-scan-schedules/{id}",
    },
    filterOptions: "api/iam-scans/{id}/filter-options",
  },

  // Findings Table Columns
  findingColumns: [
    {
      accessorKey: "severity",
      header: "Severity",
      cell: "severity_badge",
    },
    {
      accessorKey: "resource_arn",
      header: "Resource ARN",
      cell: "truncated_text",
      maxLength: 50,
    },
    {
      accessorKey: "title",
      header: "Finding",
      cell: "text",
    },
    {
      accessorKey: "description",
      header: "Description",
      cell: "truncated_text",
      maxLength: 80,
    },
    {
      accessorKey: "remediation_plan",
      header: "Remediation",
      cell: "truncated_text",
      maxLength: 60,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: "status_badges",
      width: "w-[300px]",
      displayMode: "text",
    },
  ],

  cardFields: [
    {
      key: "iam_scan_type",
      label: "Type",
      type: "subtitle",
      icon: "Shield", // Using Shield to represent IAM/Security scan type
    },
    {
      key: "scan_time_range",
      label: "Duration",
      type: "subtitle",
      icon: "Clock",
    },
    {
      type: "status",
      key: "status",
      label: "Status",
      statusMap: {
        default: { label: "Completed", color: "green" },
        scanning: { label: "Scanning", color: "orange" },
      },
    },
  ],
  footer: true,

  statsCards: false,

  // Action Menu Items (kept for structure; no API calls in mock mode)
  actions: [
    {
      key: "view_details",
      label: "View Details",
      icon: "Eye",
      action: "navigate",
      route: "/identity-management/aws-iam/finding/{id}",
    },
    {
      key: "remediate",
      label: "Auto Remediate",
      icon: "Wrench",
      action: "api",
      endpoint: "api/iam-remediation",
      method: "POST",
      condition: "has_remediation_plan",
    },
    {
      key: "ignore_finding",
      label: "Ignore Finding",
      icon: "X",
      action: "api",
      endpoint: "api/iam-findings/ignore",
      method: "PUT",
    },
  ],

  // Bulk Actions Configuration
  bulkActions: [
    {
      key: "bulkRemediate",
      label: "Bulk Remediate",
      action: "bulkRemediate",
      endpoint: "api/iam-remediation/bulk",
      method: "POST",
    },
    {
      key: "bulkIgnore",
      label: "Bulk Ignore",
      action: "bulkIgnore",
      endpoint: "api/iam-findings/bulk/ignore",
      method: "PUT",
    },
    {
      key: "exportFindings",
      label: "Export Report",
      action: "export",
      endpoint: "api/iam-findings/export",
      method: "POST",
      format: "pdf",
    },
  ],

  // Filter Configuration
  filterConfig: {
    serverSideFiltering: true,
    supportedFilters: [
      "source",
      "ai_remediation",
      "vault",
      "status",
      "verification",
    ],
    defaultFilter: "all",
    filterEndpoint: "api/iam-scans/{id}/filter-options",
    statusMapping: {
      verified: "active",
      Risky: "unvalidated",
      ignored: "ignored",
    },
    filterLabels: {
      verified: "Verified",
      Risky: "Risky",
      ignored: "Ignored",
    },
  },

  // Severity color mapping
  severityColors: {
    CRITICAL: "red",
    HIGH: "orange",
    MEDIUM: "yellow",
    LOW: "blue",
    INFORMATIONAL: "gray",
  },

  // Integration-specific features
  features: {
    hasInsights: true,
    hasBlastRadius: false,
    supportsAutoFix: true,
    supportsRemediation: true,
    supportsExport: true,
  },

  // Provider-specific configuration
  provider: {
    name: "AWS",
    type: "aws",
    color: "#FF9900",
    supportedServices: ["iam", "sts", "organizations"],
    focusAreas: [
      { id: "permissions", label: "Permissions" },
      { id: "roles", label: "Roles" },
      { id: "policies", label: "Policies" },
      { id: "privilege_escalation", label: "Privilege Escalation" },
      { id: "insecure_access", label: "Insecure Access" },
      { id: "access_keys", label: "Access Keys" },
      { id: "trust_relationships", label: "Trust Relationships" },
    ],
  },
};


